import axios from 'axios';

const BASE_URL = `/services/isnaportal/open-api/admitted-to-exam`;

export const API_ENDPOINTS = {
    applicantsList: `${BASE_URL}/export`,
    search: `${BASE_URL}/search`,
    questionsList: `${BASE_URL}/download/list`,
    dateOfUpload: `/services/isnaportal/open-api/admin/document-history/published?category=ADMITTED_FOR_EXAM`,
};

export const getDateOfUpload = () => {
    return axios.get(API_ENDPOINTS.dateOfUpload);
};

export const getAdmittedToExame = (data: any) => {
    return axios.get(API_ENDPOINTS.search, { params: { ...data } });
};

export const downloadApplicantsList = (data: any) => {
    return axios.get(API_ENDPOINTS.applicantsList, {
        params: { ...data },
        responseType: 'blob',
        headers: {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
    });
};

export const downloadQuestionsList = (data: any) => {
    return axios.get(API_ENDPOINTS.questionsList, {
        params: { ...data },
        responseType: 'blob',
        headers: {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
    });
};
